import {fabric} from 'fabric'
import Annotation from "./annotation"

function AnnotationLayer(pageNum, annoCanvas, pdfViewport) {
  this.pageNum = pageNum
  this.canvas = new fabric.Canvas(annoCanvas)
  this.pdfViewport = pdfViewport
}

AnnotationLayer.prototype.addAnnotations = function addAnnotations(annotations) {
  this.canvas.renderOnAddRemove = false
  for (const annotation of annotations) {
    let fabricObject = this.canvas._objects.find(obj => obj.object_id === annotation.object_id)
    if (fabricObject) {
      // console.log('OBJECT HAS ALREADY CREATED')
    } else {
      fabricObject = new Annotation(this, annotation)
      this.canvas.add(fabricObject)
    }
    // console.log(`Render annotations on page #${this.pageNum}`, annotation, fabricObject)
  }
  this.canvas.renderOnAddRemove = true
  this.render()
  return this
}

AnnotationLayer.prototype.render = function render() {
  this.canvas.requestRenderAll()
}

AnnotationLayer.prototype.convertToViewPortRect = function(rect, bound, viewport) {
  const vp = viewport || this.pdfViewport;
  const offset = (bound)?{x:bound[0]*vp.width,y:bound[1]*vp.height}:{x:0,y:0};
  return [
    ((rect[0]*vp.width)-offset.x),
    ((rect[1]*vp.height)-offset.y),
    (rect[2]*vp.width),
    (rect[3]*vp.height)
  ];
}

AnnotationLayer.prototype.convertToViewPortPath = function(path, bound, viewport) {
  const vp = viewport || this.pdfViewport
  const offset = (bound)?{x:bound[0]*vp.width,y:bound[1]*vp.height}:{x:0,y:0}
  const p = []
  for (let i = 0; i < path.length; i+=2) {
    p.push(new fabric.Point(((path[i]*vp.width)-offset.x),((path[i+1]*vp.height)-offset.y)))
  }
  return p
};

AnnotationLayer.prototype.convertToViewPortPoint = function(point, bound, viewport) {
  const vp = viewport || this.pdfViewport;
  const offset = (bound)?{x:bound[0]*vp.width,y:bound[1]*vp.height}:{x:0,y:0};
  return new fabric.Point(((point[0]*vp.width)-offset.x),((point[1]*vp.height)-offset.y));
}

AnnotationLayer.prototype.convertToPdfRect = function(rect, viewport) {
  const vp = viewport || this.pdfViewport;
  const x = fabric.util.toFixed(rect[0]/vp.width,8);
  const y = fabric.util.toFixed(rect[1]/vp.height,8);
  const w = fabric.util.toFixed(rect[2]/vp.width,8);
  const h = fabric.util.toFixed(rect[3]/vp.height,8);
  return [x, y, w, h];
}

AnnotationLayer.prototype.convertToPdfPath = function(paths, bound, viewport) {
  paths = paths || [];
  const that = this;
  const convertedpaths = [];
  paths.forEach(function(path){
    path = path || [];
    let convertedpath = [];
    path.forEach(function(point){
      convertedpath	= convertedpath.concat(that.convertToPdfPoint(point, bound, viewport));
    });
    convertedpaths.push(convertedpath);
  });
  return convertedpaths;
}

AnnotationLayer.prototype.convertToPdfPoint = function(point, bound, viewport) {
  const vp = viewport || this.pdfViewport;
  bound = bound || [0,0];
  const x = fabric.util.toFixed((bound[0]+point.x)/vp.width,8);
  const y = fabric.util.toFixed((bound[1]+point.y)/vp.height,8);
  return [x,y];
}


export default AnnotationLayer